import { render, staticRenderFns } from "./RecordViewer.vue?vue&type=template&id=50ee1fdc&scoped=true"
import script from "./RecordViewer.vue?vue&type=script&lang=js"
export * from "./RecordViewer.vue?vue&type=script&lang=js"
import style0 from "./RecordViewer.vue?vue&type=style&index=0&id=50ee1fdc&prod&scoped=true&lang=scss"
import style1 from "./RecordViewer.vue?vue&type=style&index=1&id=50ee1fdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ee1fdc",
  null
  
)

export default component.exports